import React from 'react';
import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog';
import HealthSystemIntegrations from './HealthSystemIntegrations';

export default function HealthSystemIntegrationsModal({ open, onOpenChange, onIntegrationsChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[min(calc(100vw-4rem),60rem)]! max-h-[calc(100dvh-4rem)]! max-w-none! p-0 gap-0 flex flex-col overflow-y-auto">
        <HealthSystemIntegrations onIntegrationsChange={onIntegrationsChange} />
      </DialogContent>
    </Dialog>
  );
}
